"use client";

import { useTranslations } from "next-intl";

const ADVANTAGES = [
	"prosConsAdvantage1",
	"prosConsAdvantage2",
	"prosConsAdvantage3",
	"prosConsAdvantage4",
	"prosConsAdvantage5",
] as const;

const DISADVANTAGES = [
	"prosConsDisadvantage1",
	"prosConsDisadvantage2",
	"prosConsDisadvantage3",
	"prosConsDisadvantage4",
	"prosConsDisadvantage5",
] as const;

export default function SandCastingProsCons() {
	const t = useTranslations("new-sand-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-center text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("prosConsTitle")}
					</h2>
				</header>

				<div className="grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-6">
					<div className="overflow-hidden bg-[#edffd5]">
						<div className="bg-[#80c26a] px-6 py-4 sm:px-8">
							<h3 className="text-base font-bold text-white sm:text-lg">{t("prosConsAdvantagesTitle")}</h3>
						</div>
						<ul className="space-y-5 px-6 py-6 sm:px-8 sm:py-8">
							{ADVANTAGES.map((key) => (
								<li key={key} className="text-sm leading-relaxed text-black md:text-base">
									{t(key)}
								</li>
							))}
						</ul>
					</div>

					<div className="overflow-hidden bg-[#f5f5f5]">
						<div className="bg-[#e5e5e5] px-6 py-4 sm:px-8">
							<h3 className="text-base font-bold text-black sm:text-lg">{t("prosConsDisadvantagesTitle")}</h3>
						</div>
						<ul className="space-y-5 px-6 py-6 sm:px-8 sm:py-8">
							{DISADVANTAGES.map((key) => (
								<li key={key} className="text-sm leading-relaxed text-black md:text-base">
									{t(key)}
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
}
